import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import {
  Exercise,
  Lecture,
  NoTimeExercise,
  PianoScene,
  Section,
  StaffExercise,
  Tutorial,
} from 'Utils/TutorialConfigHelper';
import timestamps from './level22.json';

const zero = '0:0';

const Level22 = Tutorial(22, zero, [
  Section([
    Lecture('C in the Treble Clef', zero),
    Lecture('C on the Keyboard', zero),
    Exercise(
      'Find C',
      zero,
      PianoScene({
        objectives: [{ target: 'C5', text: 'Play C on your keyboard' }],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Shifting to F Position', zero),
    Exercise(
      'F Position',
      zero,
      NoTimeExercise({ centre_align_horizontal: true, objectives: [{}, {}] }),
      [],
    ),
    Exercise('Playing in Time', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Using Both Hands', zero),
    Exercise('Hands Together', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Octave in the Right Hand', zero),
    Exercise(
      'Playing C to C',
      zero,
      NoTimeExercise({ centre_align_horizontal: true, objectives: [{}, {}] }),
      [],
    ),
    Lecture('Octave Stretch', zero),
    Exercise('Playing in Time', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Using Both Hands', zero),
    Exercise('Alternating Hands', zero, StaffExercise({ objectives: [{}] }), []),
    Exercise('Hands Together', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level22);
